import React from 'react';
import { Box } from '@mui/material';
import packageJson from '../../package.json';
import LanguageSwitcher from "./common/LanguageSwitcher";

const Footer = () => {
    return (
        <Box
            component="footer"
            sx={{
                backgroundColor: '#f0f0f0',
                px: '20px',
                mt: '20px',
                borderTop: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                height: '50px'
            }}
        >
            {/* Linker Bereich: Impressum + Dropdown nebeneinander */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <a
                    href="/impressum"
                    style={{ textDecoration: 'none', color: '#333' }}
                >
                    Impressum
                </a>

                <LanguageSwitcher />
            </Box>

            {/* Rechter Bereich: Version */}
            <Box sx={{ color: '#666' }}>
                Version {packageJson.version}
            </Box>
        </Box>
    );
};

export default Footer;
